import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import Loader from "@/components/Loader";
import EmptyState from "@/components/EmptyState";

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-black">Bonjour, {user?.name} 👋</h1>
      <p className="text-neutral-400 mt-1">{user?.email}</p>

      <div className="grid sm:grid-cols-3 gap-3 mt-6">
        <Link to="/tickets" className="card-hsg p-5 hover:-translate-y-1 transition-transform">
          <div className="text-3xl">🎟️</div>
          <div className="font-bold mt-2">Acheter des billets</div>
          <div className="text-neutral-400 text-sm mt-1">Pass 1 ou 2 jours, famille, VIP…</div>
        </Link>
        <Link to="/ateliers" className="card-hsg p-5 hover:-translate-y-1 transition-transform">
          <div className="text-3xl">🎨</div>
          <div className="font-bold mt-2">Réserver un atelier</div>
          <div className="text-neutral-400 text-sm mt-1">40+ ateliers pour enfants</div>
        </Link>
        <Link to="/bracelet" className="card-hsg p-5 hover:-translate-y-1 transition-transform">
          <div className="text-3xl">🎁</div>
          <div className="font-bold mt-2">Bracelet cashless</div>
          <div className="text-neutral-400 text-sm mt-1">Solde et recharge</div>
        </Link>
      </div>

      <h2 className="text-2xl font-bold mt-10 mb-3">Mes commandes</h2>
      {orders === null ? <Loader /> :
        orders.length === 0 ? <EmptyState title="Aucune commande" subtitle="Vos achats apparaîtront ici." action={<Link to="/tickets" className="brand-gradient-btn px-4 py-2 rounded-lg text-sm">Voir la billetterie</Link>} /> :
        (<div className="space-y-3">
          {orders.map((o) => (
            <Link key={o.id} to={`/order/${o.id}`} className="card-hsg p-5 flex justify-between items-center hover:-translate-y-0.5 transition">
              <div>
                <div className="font-mono text-xs text-neutral-500">#{o.id.slice(0, 8).toUpperCase()}</div>
                <div className="font-bold mt-1">{o.kind === "ticket" ? "Billets" : o.kind === "bracelet" ? "Recharge bracelet" : o.kind}</div>
                <div className="text-sm text-neutral-400">{new Date(o.created_at).toLocaleString("fr-CH")}</div>
              </div>
              <div className="text-right">
                <div className="font-black">CHF {Number(o.total_chf || 0).toFixed(2)}</div>
                <div className="text-xs text-[#A1C861] mt-1">{o.status}</div>
              </div>
            </Link>
          ))}
        </div>)
      }
    </div>
  );
}
